module.exports = __webpack_public_path__ + "img/support_heart.32471c94.jpg";